
interface SectionHeaderProps extends React.PropsWithChildren<{}> {
}

export default function SectionHeader({ children }: SectionHeaderProps) {
    return (
        <div className="border-b border-b-gray-200 my-4 text-engage-500 font-bold text-base sm:text-lg">
            {children}
        </div>
    );
}
